import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  CLICK,
  CLICK_APPLY,
} from 'externals/_tracking/types/eventTypes.constants';
import {
  getDefaultEventPropertiesForLifeInsurance,
  getFullAttributes,
} from 'helpers/tracking.helpers';
import { useConfig } from 'hook/config.hook';
import { useSeenOfferPixel } from 'hook/helper.hook';
import { fetchApplyNowTracking } from 'externals/_services/tracking.service';
import { wrapService } from 'actions/service_wrapper.actions';
import {
  plantMetadataInLocalStorageAndReturnTransferUrl,
  convertProps,
  setPartnerNameAndImageWithId,
} from 'partial/OfferManager/holder/genericOfferLogic';
import useTrackingMetadata from 'externals/_tracking/useTrackingMetadata';
import { getMrphPageFormFactor } from 'helpers/metadataLogic.helpers';
import { useDispatch, useSelector } from 'react-redux';
import { useLogger } from 'hook/error.hook';
import { cleanPopupPaths } from 'helpers/path.helper';
import { LIFE_INSURANCE_DETAIL } from 'types/mrph.pageName.constants';
import { LIFE_INSURANCE_VERTICAL } from 'types/marketplaceTiles.constants';
import { OFFERS_IMAGE_PROXY } from 'helpers/env';

const a_fetchApplyNowTracking = wrapService(fetchApplyNowTracking, {
  name: 'ai_fetchApplyNowTracking',
});

const LifeInsuranceOfferHolder = props => {
  const logger = useLogger({
    name: 'LifeInsuranceOfferHolder',
  });

  const isModal = props.isModal;
  const { config } = useConfig();
  const applyNowLabelText = `on ${props.offerMetadata.displayName}'s ${config?.secureWebsiteDisclaimer}`;
  const [isLoading, setIsLoading] = useState(false);

  const trackingManager = useTrackingMetadata();
  const { pageNameMeta, setPagePosition } = trackingManager;
  const dispatch = useDispatch();
  const { ocfLoggedIn } = useSelector(state => ({
    ocfLoggedIn: state.app.ocfLoggedIn,
  }));

  const defaultEventHandler = (name, attributes = {}) => {
    const fullAttributes = getFullAttributes({
      partner: props.partner,
      pagePosition: props.pagePosition,
      modulePosition: props.modulePosition,
      offerMetadata: props.offerMetadata,
      position: props.position,
      extraAttributes: props.extraAttributes,
      attributes: attributes,
      isModal: isModal,
    });
    props.eventHandler(name, fullAttributes);
  };

  const onMouseClickDetails = e => {
    defaultEventHandler(CLICK, {
      'Click Type': 'Highlights',
      'Page Name': LIFE_INSURANCE_DETAIL,
    });

    openDetailsTab();
  };

  const openDetailsTab = type => {
    const currentPath = props.location.pathname;
    const cleanPath = cleanPopupPaths(currentPath);
    const hashTag = type ? `#${type}` : '';
    const finalUrl = `${cleanPath}/offerDetails/lifeInsurance/${props.offerMetadata.impressionId}${hashTag}`;
    setPagePosition(props.pagePosition);
    props.history.replace(finalUrl);
  };

  const onApplyClick = e => {
    e.preventDefault();
    onApplyClickFn();
  };

  const onApplyClickFn = () => {
    if (isLoading) return;
    setIsLoading(true);
    const id = setPartnerNameAndImageWithId(
      props.offerMetadata.name,
      props.offerMetadata.imageLink,
    );
    const propsForBackend = convertProps(
      getFullAttributes({
        partner: props.partner,
        pagePosition: props.pagePosition,
        modulePosition: props.modulePosition,
        offerMetadata: props.offerMetadata,
        position: props.position,
        extraAttributes: props.extraAttributes,
        attributes: {
          'Page Name': pageNameMeta,
          'Page Form Factor': getMrphPageFormFactor(),
          Vertical: LIFE_INSURANCE_VERTICAL,
        },
        isModal: isModal,
        includeBackendRefCode: true,
      }),
    );

    let windowReference = window.open();
    dispatch(
      a_fetchApplyNowTracking(props.offerMetadata.clickUrl, {
        props: propsForBackend,
      }),
    )
      .then(trackingMetadata => {
        defaultEventHandler(CLICK_APPLY, {
          'Click Type': 'Apply',
          'Click ID': trackingMetadata.clickId,
          'Page Form Factor': getMrphPageFormFactor(),
          Partner: props.offerMetadata.displayName,
        });

        const transferUrl = plantMetadataInLocalStorageAndReturnTransferUrl(
          trackingMetadata.partnerUrl,
          id,
          null,
          ocfLoggedIn,
          props.isPublicUser,
        );

        windowReference.location = transferUrl;
        setIsLoading(false);
      })
      .catch(err => {
        logger.showError('A problem happened while Transferring', err.message);
        logger.reportAPIError(err);
        windowReference.close();
        setIsLoading(false);
      });
  };

  const trackingAttr = getDefaultEventPropertiesForLifeInsurance({
    pagePosition: props.pagePosition,
    offerMetadata: props.offerMetadata,
    attributes: {
      'Module Name': props.pagePosition,
      'Module Position': props.modulePosition,
    },
  });

  const seenOffer = useSeenOfferPixel(trackingAttr);

  return (
    <props.lifeInsuranceTemplate
      {...props}
      offerImageLinkUrlProxy={`${OFFERS_IMAGE_PROXY}${props.offerMetadata?.imageLink}`}
      clickDetailsHandler={onMouseClickDetails}
      clickApplyHandler={onApplyClick}
      config={config}
      seenPixel={seenOffer}
      applyNowLabelText={applyNowLabelText}
    />
  );
};

const connectedAutoLifeOfferHolder = withRouter(LifeInsuranceOfferHolder);

export default connectedAutoLifeOfferHolder;
